import React from 'react';
import { Modal, Popover } from 'antd';
import PropTypes from 'prop-types';

import TotalIcon from 'components/Icons/TotalIcon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import PageHeader from 'components/PageHeader';
import { RTL_LANGUAGES } from 'constants/languages';
import './Totals.scss';

const Totals = ({ setVisible, isModalVisible, totalText, popOverContent, language }) => {
  const { width } = useWindowDimensions();
  const isRTL = RTL_LANGUAGES.includes(language?.toLowerCase());

  if (width < 768) {
    return (
      <div className="totals-popover-container">
        <div onClick={() => setVisible(true)} className="total-btn">
          <div className="icon">
            <TotalIcon />
          </div>
          {totalText}
        </div>

        <Modal
          maskStyle={{ zIndex: 1009 }}
          className={`totals-popover ${isRTL ? 'language-rtl' : ''}`}
          centered
          visible={isModalVisible}
          onCancel={() => setVisible(false)}
          footer={null}
          title={<PageHeader pageTitle="Summary" />}>
          {popOverContent}
        </Modal>
      </div>
    );
  }

  return (
    <div className="totals-popover-container">
      <Popover
        overlayClassName={`totals-popover ${isRTL ? 'language-rtl' : ''}`}
        content={popOverContent}
        trigger="click"
        placement="topRight"
        visible={isModalVisible}
        onVisibleChange={(value) => value && setVisible(value)}>
        <div className="total-btn">
          <div className="icon">
            <TotalIcon />
          </div>
          {totalText}
        </div>
      </Popover>
    </div>
  );
};

Totals.defaultProps = {
  setVisible: () => {},
  isModalVisible: false,
  totalText: '',
  popOverContent: null,
  language: null,
};

Totals.propTypes = {
  setVisible: PropTypes.func,
  isModalVisible: PropTypes.bool,
  totalText: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  popOverContent: PropTypes.node,
  language: PropTypes.string,
};

export default Totals;
